/* loaded by smart-asset */
export default require("./assets/pallet-loaded.i.svg")